import { RestApi } from "../services/rest-api";
import { AccountMaster, AgentMaster, ItemMaster } from "./masters.model";
import { PagingDataModel } from "./paging.model";

export interface SaleOrderItemModel {
  item: ItemMaster;
  description: string;
  qty: number;
  rate: number;
  amt: number;
}

export interface SaleOrderAdvanceModel {
  date: string;
  narration: string;
  amt: number;
}

export interface SaleOrderModel {
  id?: number;
  account?: AccountMaster;
  agent?: AgentMaster;
  ac_name?: string;
  agent_name?: string;
  so_no: string;
  so_date: string;
  closed_status: string;
  remarks?: string;
  items: Array<SaleOrderItemModel>;
  advances: Array<SaleOrderAdvanceModel>;
  qty: number;
  amt: number;
  gst: number;
  gst_amt: number;
  total_amt: number;
}

export interface SaleOrderExtendedModel extends SaleOrderModel {
  recd_qty: number;
  recd_per: number;
}

export interface RptSaleOrderItemBalanceModel {
  item_id: number;
  item_name: string;
  ordered_qty: number;
  recd_qty: number;
}

export interface RptItemSaleOrderBalanceModel {
  v_no: string;
  v_date: string;
  qty: number;
  balance: number;
}

export const fetchSaleOrderList = async (page: number, inputs: any, authInfo: any) => {
  return await RestApi<PagingDataModel<SaleOrderExtendedModel>>('post', `saleOrderList?p=${page}`, inputs, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const fetchSaleOrderShow = async (id: string, authInfo: any) => {
  return await RestApi<any>('post', 'saleOrderShow', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const deleteSaleOrder = async (id: number, authInfo: any) => {
  return await RestApi<any>('post', 'deleteSaleOrder', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};

export const fetchRptSaleOrderItemBalance = async (authInfo: any) => {
  return await RestApi<Array<RptSaleOrderItemBalanceModel>>('post', 'rptSaleOrderItemBalance', {}, authInfo.user.authorization).then(function (response) {
    return response;
  });
};


export const fetchRptItemSaleOrderBalance = async (id: number, authInfo: any) => {
  return await RestApi<Record<string, Array<RptItemSaleOrderBalanceModel>>>('post', 'rptItemSaleOrderBalance', { id }, authInfo.user.authorization).then(function (response) {
    return response;
  });
};
